// extracted by mini-css-extract-plugin
export default {"zoomModal":"N3-z"};